<template>
  <div>
    <Header></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="min-height:420px;background-color: #f5f5f5">
      <choice-apply></choice-apply>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemMember from '@/components/item/itemMember.vue'
import choiceApply from '@/components/apply/choiceApply.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'
import ChoiceApply from './apply/choiceApply'

export default {
  name: 'apply',
  data () {
    return {
      // 所在页面的名称
      topName: 'apply',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/apply',
      secondtest: '会员注册',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: []
    }
  },
  components: {
    ChoiceApply,
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemMember: itemMember,
    choiceApply: choiceApply
  },
  methods: {
    // 副导航栏
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.member = res.member
        this.cate = res.cate
      })
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apply.vue